// Legacy /me/item/:itemId/trips/calendar landing. The calendar used to be its
// own page; it now renders below the trips list, on the list's URL. Bookmarks
// and links shared with the crew still point here.
//
// The query string travels along, and that is the whole point: ?month= and
// ?trips= mean exactly the same thing on the list URL, so a link someone sent
// last week still opens on the month and the selection it named. `replace`, so
// Back goes wherever they came from rather than bouncing off this route.

import { Navigate, useParams, useLocation } from 'react-router-dom';
import { urlForTrips } from '../../fleet-shared/Urls.mjs';

export const TripsCalendarRedirect = () => {
  const { itemId } = useParams();
  const { search } = useLocation();

  return <Navigate to={`${urlForTrips(itemId)}${search}`} replace />;
};

export default TripsCalendarRedirect;
